"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TradingPlatformOverview() {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  useEffect(() => {
    const handleScroll = () => {
      if (!parallaxRef.current) return;
      const scrolled = window.scrollY;
      const element = parallaxRef.current;
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + scrolled;
      const elementHeight = rect.height;
      const windowHeight = window.innerHeight;
      if (scrolled + windowHeight > elementTop && scrolled < elementTop + elementHeight) {
        const offset = (scrolled + windowHeight - elementTop) / (windowHeight + elementHeight);
        const translateY = offset * 80 - 40;
        parallaxRef.current.style.transform = `translateY(${translateY}px) scale(1.05)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="trading-platform-overview" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden py-24 px-4">
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545031/img/trading_dashboard_multi_layer.png)] will-change-transform" style={{
      filter: "brightness(0.4) contrast(1.1)"
    }} />

      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60" />

      <div ref={contentRef} className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h1 className="font-display font-bold text-[clamp(2.5rem,5vw,3.5rem)] leading-[1.2] tracking-tight text-white mb-6">
          Institutional-Grade Digital Asset Trading
        </h1>

        <p className="text-lg leading-[1.6] text-white/90 max-w-2xl mx-auto mb-10">
          West Indian Digital combines energy infrastructure expertise with systematic trading strategies. Our platform operates with disciplined risk management, institutional governance standards, and transparent execution across digital asset markets.
        </p>

        <Link to="/ContactPage">
          <Button size="lg" className="bg-accent text-foreground-accent px-8 py-3 font-semibold tracking-wide hover:bg-accent-hover hover:scale-[1.02] hover:shadow-medium active:bg-accent-active active:scale-[0.98] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] shadow-strong">
            Learn More About Our Trading Operations
          </Button>
        </Link>
      </div>
    </section>;
}